import type { FC } from "react";
import { Card, MatchCase } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { useMedia, YStack } from "tamagui";

import { api } from "~/utils/api";
import { useConstructScales } from "~/hooks";
import { Scales, ScalesMobile } from "./scales-card";

export const CriticalScales: FC = () => {
  const { sm } = useMedia();

  const { t } = useTranslation("results");
  const [data] = api.scores.criticalScales.useSuspenseQuery();
  const scales = useConstructScales(data);

  if (!scales.length) return null;

  return (
    <Card
      width={"100%"}
      maxWidth={952}
      data-id={"critical-scales-container"}
      gap={"$5"}
      shadow={"none"}
      variant={"borderless"}
      size={"sm"}
      $gtMd={{
        shadow: "md",
        variant: "default",
        size: "md",
      }}
    >
      <YStack data-id={"critical-scales-header"} gap={"$1"} alignItems="center">
        <Card.Title data-id={"critical-scales-title"}>
          {t("scalesCritical.title")}
        </Card.Title>
        <Card.Subtitle data-id={"critical-scales-subtitle"} textAlign="center">
          {t("scalesCritical.subTitle")}
        </Card.Subtitle>
      </YStack>
      <MatchCase value={sm}>
        {(Case) => (
          <>
            <Case condition={false}>
              <Scales scales={scales} />
            </Case>

            <Case condition={true}>
              <ScalesMobile scales={scales} />
            </Case>
          </>
        )}
      </MatchCase>
    </Card>
  );
};
